import { render, staticRenderFns } from "./PhotoEdit.vue?vue&type=template&id=07741d48&scoped=true&"
import script from "./PhotoEdit.vue?vue&type=script&lang=js&"
export * from "./PhotoEdit.vue?vue&type=script&lang=js&"
import style0 from "./PhotoEdit.vue?vue&type=style&index=0&id=07741d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07741d48",
  null
  
)

component.options.__file = "PhotoEdit.vue"
export default component.exports